import React from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { login, profileData } from "../../store/reducers/userSlice";
import { API_POST__LOGIN } from "api/auth";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { ConfigurePrivateAxiosInstance } from "config/axios";
import { useProfileCTX } from "config/ProfileCTX";

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setProfileData } = useProfileCTX();

  console.log(process.env.REACT_APP_APPLICATION_NAME, "applicationamae");
  return (
    <>
      <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Sign In
          </h4>
          <p className="mb-9 ml-1 text-base text-gray-600">
            Enter your email and password to sign in!
          </p>
          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={Yup.object({
              email: Yup.string()
                .email("Invalid email address")
                .required("Required"),
              password: Yup.string()
                .min(4, "Password must be at least 4 characters")
                .required("Required"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              try {
                const userData = await API_POST__LOGIN(values);
                console.log("userData", userData?.data);
                localStorage.setItem(
                  "userData",
                  JSON.stringify(userData?.data)
                );
                dispatch(login(userData));
                dispatch(profileData(userData?.data?.data));
                setProfileData(userData?.data?.data);
                ConfigurePrivateAxiosInstance(userData?.token);
                toast.success(userData?.message);
                navigate("/admin/dashboared");
                window.location.reload();

              } catch (error) {
                console.log("error", error);
                toast.error(error?.response?.data?.message);

                // setFieldError("email", "Invalid email or password");
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting }) => (
              <Form className="w-full">
                <div className="mb-3">
                  <Field
                    className={`mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${document.body.classList.contains("dark") ? "text-[white]" : "" } `}
                    type="text"
                    name="email"
                    placeholder="mail@simmmple.com"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500"
                  />
                </div>

                <div className="mb-3">
                  <Field
                    className={`mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${document.body.classList.contains("dark") ? "text-[white]" : "" }`}
                    type="password"
                    name="password"
                    placeholder="Min. 8 characters"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-red-500"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                >
                  {isSubmitting ? "Signing in...." : "  Sign In"}
                </button>
              </Form>
            )}
          </Formik>

          <div className="mt-4">
            <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
              Not registered yet?
            </span>
            <Link
              to="/auth/forgetpass"
              className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            >
              Forget Password
              {/* Create an account */}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
